import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { CommonService } from '../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class FooterNavigationService {
  openCloseSiteTourAction = new BehaviorSubject(false)
  openCloseVideoTourAction = new BehaviorSubject(false)
  videoLinkUrl = new BehaviorSubject({ url: '', valid: false })

  constructor(public commonService: CommonService) {}

  fetchTermsConditionsLink() {
    const urlParam = ['cms', 'components', 'TermsConditionsPDF']
    const apiParams = {
      fields: 'DEFAULT',
    }
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url, apiParams)
  }
}
